module.exports = __webpack_public_path__ + "static/img/klaspad-logo.0405f2d9.png";